import {
  Button,
  ModalContent,
  ModalProps,
  createModalComponent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
  DialogClose,
} from "@shortsworks/ui";

interface CommonErrorModalProps {
  title: string;
  description: string;
}

const CommonModalContent = (props: ModalProps<CommonErrorModalProps>) => {
  return (
    <ModalContent>
      <DialogHeader>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogDescription>{props.description}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild></DialogClose>
        <Button
          onClick={() => props.close()}
          className="p-0 w-[104px] h-[40px]"
        >
          확인
        </Button>
      </DialogFooter>
    </ModalContent>
  );
};

export const CommonModal = createModalComponent(CommonModalContent);

interface CommonErrorModalProps {
  title: string;
  description: string;
}
const CommonSelectContent = (props: ModalProps<CommonErrorModalProps>) => {
  // 타켓에 대한  타입 체크
  const handleClickClose = (event: React.MouseEvent<HTMLDivElement>) => {
    const value = (event.target as HTMLElement).dataset.value === 'true';
    return props.close(value);
  };

  return (
    <ModalContent>
      <DialogHeader>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogDescription>{props.description}</DialogDescription>
      </DialogHeader>
      <DialogFooter onClick={handleClickClose} className="gap-4">
        <Button data-value="true" className="w-full md:w-[104px] h-[40px]">
          확인
        </Button>
        <Button data-value="false" className="p-0 w-full md:w-[104px] h-[40px]">
          취소
        </Button>
      </DialogFooter>
    </ModalContent>
  );
};

export const CommonSelectModal = createModalComponent(CommonSelectContent);
